/**
 * Search results: AJAX load more.
 */
jQuery(function ($) {
	if (typeof window.localVars === 'undefined') {
		return;
	}

	const $blocks = $('.js-search-results');
	if (!$blocks.length) {
		return;
	}

	function buildSkeletonCard() {
		return (
			'<article class="blog-posts-skeleton post-box column" aria-hidden="true">' +
				'<div class="blog-posts-skeleton__image blog-posts-skeleton-shimmer"></div>' +
				'<div class="blog-posts-skeleton__body">' +
					'<span class="blog-posts-skeleton__title blog-posts-skeleton-shimmer"></span>' +
					'<span class="blog-posts-skeleton__line blog-posts-skeleton-shimmer"></span>' +
					'<span class="blog-posts-skeleton__line blog-posts-skeleton__line--short blog-posts-skeleton-shimmer"></span>' +
				'</div>' +
			'</article>'
		);
	}

	function buildSkeletonMarkup(count) {
		const cards = [];
		for (let i = 0; i < count; i++) {
			cards.push(buildSkeletonCard());
		}
		return cards.join('');
	}

	$blocks.each(function () {
		const $root = $(this);
		const $grid = $root.find('.blog-posts__grid');
		const $loadMoreWrap = $root.find('.blog-posts__load-more');
		const $loadMoreBtn = $root.find('.js-search-load-more');
		const $status = $root.find('.blog-posts__status');
		const perPage = parseInt($root.attr('data-per-page'), 10) || 10;
		const searchQuery = $root.attr('data-search') || '';

		let loading = false;
		let currentPage = parseInt($root.attr('data-page'), 10) || 1;
		let hasMore = $root.attr('data-has-more') === '1';

		function setHasMore(value) {
			hasMore = value;
			$root.attr('data-has-more', value ? '1' : '0');
			$loadMoreWrap.toggleClass('is-hidden', !value);
		}

		function setLoadingState(isLoading) {
			$root.toggleClass('is-loading', isLoading);
			$root.attr('aria-busy', isLoading ? 'true' : 'false');
		}

		function removeSkeleton() {
			$grid.find('.blog-posts-skeleton').remove();
		}

		function showSkeleton() {
			removeSkeleton();
			$grid.append(buildSkeletonMarkup(perPage));
		}

		$loadMoreBtn.on('click', function (e) {
			e.preventDefault();

			if (loading || !hasMore || !searchQuery) {
				return;
			}

			loading = true;
			setLoadingState(true);
			$status.text('Loading');
			showSkeleton();

			$.ajax({
				url: window.localVars.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'dma_search_results',
					nonce: window.localVars.nonce,
					search: searchQuery,
					page: currentPage + 1,
					per_page: perPage,
				},
			})
				.done(function (res) {
					removeSkeleton();

					if (!res || !res.success || !res.data) {
						$status.text('');
						return;
					}

					const payload = res.data;

					if (payload.html) {
						$grid.append(payload.html);
					}

					currentPage = payload.page || currentPage + 1;
					$root.attr('data-page', currentPage);
					setHasMore(!!payload.has_more);
					$status.text('');
				})
				.fail(function () {
					removeSkeleton();
					$status.text('');
				})
				.always(function () {
					loading = false;
					setLoadingState(false);
				});
		});
	});
});
